module.exports = __webpack_public_path__ + "static/media/brand-story-img3.63f2358e.png";